import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetProjectSpocDetailsRPC } from "./getProjectSpocDetailsRPC";

export class GetProjectSpocDetailsRPCClientImpl extends GetProjectSpocDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetProjectSpocDetailsRPC.Request): Promise<LeoRPCResult<GetProjectSpocDetailsRPC.Response, GetProjectSpocDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetProjectSpocDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetProjectSpocDetailsRPC.ResponseDTO,
      GetProjectSpocDetailsRPC.Errors.ErrorsDTO,
      GetProjectSpocDetailsRPC.Response,
      GetProjectSpocDetailsRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetProjectSpocDetails",
      GetProjectSpocDetailsRPC.Response.fromDTO,
      GetProjectSpocDetailsRPC.Errors.fromDTO
    );
  }
}
